import { parseUtcInstant } from "./dateTimeUtils";

export function sortRowsByTimeDesc(rows, timeAccessor) {
  return [...rows].sort((a, b) => {
    const ta = parseUtcInstant(timeAccessor(a))?.valueOf() ?? 0;
    const tb = parseUtcInstant(timeAccessor(b))?.valueOf() ?? 0;
    return tb - ta;
  });
}

export function sortRowsByTimeAsc(rows, timeAccessor) {
  return [...rows].sort((a, b) => {
    const ta = parseUtcInstant(timeAccessor(a))?.valueOf() ?? 0;
    const tb = parseUtcInstant(timeAccessor(b))?.valueOf() ?? 0;
    return ta - tb;
  });
}

export function mergeLiveTelemetryRows({
  historyRows,
  liveRows,
  limit,
  dedupeKey,
  matchesDateFilter,
  dateRange,
  timeAccessor,
}) {
  const filteredHistory = dateRange
    ? historyRows.filter((row) => matchesDateFilter(row, dateRange))
    : historyRows;

  if (!liveRows.length) {
    return limit ? filteredHistory.slice(0, limit) : filteredHistory;
  }

  const historyKeys = new Set(filteredHistory.map(dedupeKey));
  const prepend = liveRows.filter(
    (row) =>
      !historyKeys.has(dedupeKey(row)) && matchesDateFilter(row, dateRange),
  );

  if (!prepend.length) {
    return limit ? filteredHistory.slice(0, limit) : filteredHistory;
  }

  const merged = sortRowsByTimeDesc(
    [...prepend, ...filteredHistory],
    timeAccessor,
  );
  return limit ? merged.slice(0, limit) : merged;
}

/** Append socket readings to chart history in chronological order (no API refetch). */
export function mergeLiveChartTelemetryRows({
  historyRows,
  liveRows,
  dedupeKey,
  matchesDateFilter,
  dateRange,
  timeAccessor,
}) {
  const filteredHistory = dateRange
    ? historyRows.filter((row) => matchesDateFilter(row, dateRange))
    : historyRows;

  if (!liveRows.length) return filteredHistory;

  const historyKeys = new Set(filteredHistory.map(dedupeKey));
  const append = liveRows.filter(
    (row) =>
      !historyKeys.has(dedupeKey(row)) && matchesDateFilter(row, dateRange),
  );

  if (!append.length) return filteredHistory;

  return sortRowsByTimeAsc([...filteredHistory, ...append], timeAccessor);
}

export function countLiveOnlyRows({
  historyRows,
  liveRows,
  dedupeKey,
  matchesDateFilter,
  dateRange,
  timeAccessor,
}) {
  const historyKeys = new Set(historyRows.map(dedupeKey));
  return liveRows.filter(
    (row) =>
      !historyKeys.has(dedupeKey(row)) && matchesDateFilter(row, dateRange),
  ).length;
}
